<template>
  <div class="box">
    <div class="content">
      <div class="center">
        <div class="top_title">
          <div class="lefts"><img src="./images/left.png" alt="" /></div>
          <div class="centers">{{ explain[0]?.title }}测试题</div>
          <div class="rights"><img src="./images/right.png" alt="" /></div>
        </div>
      </div>
      <div class="progress_bar">
        <div class="progress_left">
          <div class="long"></div>
          <div class="short" :style="{ width: widths + `%` }"></div>
        </div>
        <div class="progress_right">
          <div class="num">{{ idx + 1 }}</div>
          <div class="num1">/{{ list.scaleQuestions?.length }}</div>
        </div>
      </div>
      <!-- 多选题目内容 -->
      <div class="body" v-if="list?.questionsType === 1">
        <!-- 多选 -->
        <div
          class="body_box"
          v-for="(item, index) in list?.scaleQuestions"
          :key="index"
          v-show="index === idx"
        >
          <div class="body_title">
            {{ `${item?.sort}、 ${item?.title} ` }}
          </div>
          <div class="options">
            <div class="rad" v-for="(t, i) in item?.answer" :key="i">
              <el-checkbox
                v-model="t.score"
                :true-label="t.value"
                false-label="0"
                >{{ `${t.key}. ${t.name} ` }}</el-checkbox
              >
            </div>
            <div class="btn">
              <button class="btn3" @click="up(index)">重新测试</button>
              <button
                class="btn2"
                v-if="list.scaleQuestions?.length - 1 == idx"
                @click="next(index)"
              >
                点击进入下一项测试
              </button>
              <button class="btn3" v-else @click="next(index)">下一题</button>
            </div>
          </div>
        </div>
      </div>
      <!-- 单选题目内容 -->
      <div class="body" v-if="list.questionsType === 0">
        <!-- 多选 -->
        <div
          class="body_box"
          v-for="(item, index) in list.scaleQuestions"
          :key="index"
          v-show="index === idx"
        >
          <div class="body_title">
            {{ `${item.sort}、 ${item.title} ` }}
          </div>
          <div class="options">
            <div class="rad" v-for="(t, i) in item.answer" :key="i">
              <el-radio-group v-model="item.type" @change="next(index)">
                <el-radio :label="t.value">{{
                  `${t.key}. ${t.name} `
                }}</el-radio>
              </el-radio-group>
            </div>
            <div class="btn">
              <button class="btn3" @click="up(index)">重新测试</button>
              <button
                class="btn2"
                v-if="list.scaleQuestions.length - 1 == idx"
                @click="submit()"
              >
                提交
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- 单选题目内容 -->
      <div class="body" v-if="list.questionsType === 2">
        <!-- 多选 -->
        <div
          class="body_box"
          v-for="(item, index) in list.scaleQuestions"
          :key="index"
          v-show="index === idx"
        >
          <div class="body_title">
            {{ `${item.sort}、 ${item.title} ` }}
          </div>
          <div class="options">
            <div class="rad" v-for="(t, i) in item.answer" :key="i">
              <el-radio-group v-model="item.type" @change="next(index)">
                <el-radio :label="t.value">{{
                  `${t.key}. ${t.name} `
                }}</el-radio>
              </el-radio-group>
            </div>
            <div class="btn">
              <button class="btn3" @click="up(index)">重新测试</button>
              <button
                class="btn2"
                v-if="list.scaleQuestions.length - 1 == idx"
                @click="submit()"
              >
                提交
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetScaleQuestions,
  CustomBusScale,
  GetBusScaleDescriptiont,
} from "@/api/home";
export default {
  name: "XTesting",

  data() {
    return {
      explain: "", //说明title
      list: "",
      idx: 0,
      widths: 1,
      data: {
        ScaleId: "",
        CustomId: "",
        Inputs: [
          {
            total: 0,
          },
        ],
      },
      data1: {
        ScaleId: "",
        CustomId: "",
        Inputs: [],
      },
      arr: [],
    };
  },

  async mounted() {
    this.GetScale();
    // 获取测试标题
    const resa = await GetBusScaleDescriptiont(this.$route.query.ScaleId);
    this.explain = resa.result.busScaleDescriptions;
    this.data.ScaleId = this.$route.query.ScaleId; //测试项id
    this.data.CustomId = this.$store.state.user.studentInfo.userId; //用户id
    this.data1.ScaleId = this.$route.query.ScaleId; //测试项id
    this.data1.CustomId = this.$store.state.user.studentInfo.userId; //用户id
  },

  methods: {
    async GetScale() {
      const res = await GetScaleQuestions(this.$route.query.ScaleId);
      this.list = res.data || res.result;
    },
    up() {
      this.$confirm("真的确定重新测试吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/psychologyTesting",
            query: { ScaleId: this.data.ScaleId },
          });
        })
        .catch(() => {});
    },
    submit() {
      if (this.list.questionsType === 2) {
        this.bus1();
      } else {
        if (this.data.Inputs[0].total === 0) {
          this.arr.forEach((item) => {
            this.data.Inputs[0].total += item.total;
          });
          this.bus();
        }
      }
    },
    next(index) {
      setTimeout(() => {
        if (this.list.questionsType === 0) {
          if (this.idx != this.list.scaleQuestions.length - 1) {
            let obj = {
              total: 0,
            };
            obj.total = parseInt(this.list.scaleQuestions[index].type);
            if (obj.total != -1) {
              this.arr.push(obj);
              this.idx++;
              this.widths += 100 / this.list.scaleQuestions.length;
            }
          } else {
            let obj = {
              total: 0,
            };
            obj.total = parseInt(this.list.scaleQuestions[index].type);
            if (obj.total != -1) {
              this.arr.push(obj);
              // 提交
              this.widths = 100;
            }
          }
        }
        if (this.list.questionsType === 2) {
          if (this.idx != this.list.scaleQuestions.length - 1) {
            let obj = {
              value: 0,
              name: "",
            };
            obj.value = parseInt(this.list.scaleQuestions[index].type);
            this.list.scaleQuestions[index].answer.forEach((item) => {
              obj.name = item.tag;
            });
            if (obj.value != -1) {
              this.data1.Inputs.push(obj);
              this.idx++;
              this.widths += 100 / this.list.scaleQuestions.length;
            }
          } else {
            let obj = {
              value: 0,
              name: "",
            };
            obj.value = parseInt(this.list.scaleQuestions[index].type);
            this.list.scaleQuestions[index].answer.forEach((item) => {
              obj.name = item.tag;
            });
            if (obj.value != "") {
              this.data1.Inputs.push(obj);
              this.widths = 100;
            }
          }
        }
      }, 600);
    },
    async bus() {
      const res = await CustomBusScale({ ...this.data });
      this.$router.push({ path: "/submit", query: { id: res.result.id } });
    },
    async bus1() {
      const res = await CustomBusScale({ ...this.data1 });
      this.$router.push({
        path: "/submit",
        query: { id: res.result.id, scaleId: res.result.scaleId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-width: 1200px;
  .content {
    width: 100%;
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    .center {
      width: 100%;
      display: flex;
      margin-top: 48px;
      justify-content: center;
      .top_title {
        display: flex;
        align-items: center;
        .lefts {
          width: 40.21px;
          height: 21.21px;
        }
        .centers {
          font-size: 24px;
          color: #333;
          margin: 0 20px;
        }
        .rights {
          width: 40.21px;
          height: 21.21px;
        }
      }
    }
    .progress_bar {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 67px;
      .progress_left {
        position: relative;
        width: 653px;
        height: 15px;
        .long {
          width: 100%;
          height: 100%;
          background: rgba(57, 100, 230, 0.1);
          border-radius: 18px 18px 18px 18px;
          opacity: 1;
        }
        .short {
          position: absolute;
          top: 0;
          left: 0;
          width: 10%;
          height: 100%;
          background: #3964e6;
          border-radius: 18px 18px 18px 18px;
          opacity: 1;
        }
      }
      .progress_right {
        display: flex;
        align-items: center;
        .num {
          font-size: 30px;
          font-weight: bold;
          color: #3964e6;
        }
        .num1 {
          font-size: 20px;
          color: #333;
        }
      }
    }
    .body {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: 61px 0;
      .body_box {
        width: 90%;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        border: 1px solid #c7c7c7;
        .body_title {
          margin: 46px 0 21px 38px;
          font-size: 20px;
          color: #333;
          font-weight: bold;
        }
        .options {
          margin: 0 0 42px 72px;
          display: flex;
          flex-wrap: wrap;
          .rad {
            width: 400px;
            height: 40px;
            background: #fff; //#f2f6ff
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            border: 1px solid #eaeaea; // #3964e6;
            margin: 0 50px 30px 50px;
            display: flex;
            align-items: center;
            ::v-deep .el-radio-group {
              width: 100%;
            }
            ::v-deep .el-radio {
              margin-left: 30px;
              width: 100%;
              height: 100%;
              line-height: 40px;
            }
            ::v-deep .el-checkbox {
              margin-left: 30px;
              width: 100%;
              height: 100%;
            }
            ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
              background-color: #3964e6;
              border-color: #3964e6;
            }
            ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
              color: #3964e6;
            }
          }
          .btn {
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 55px;
            .btn2 {
              width: 200px;
              height: 30px;
              color: #fff;
              background: #68bf7b;
              border-radius: 18px 18px 18px 18px;
              opacity: 1;
              border: 0;
              border: solid 1px #3964e6;
              font-size: 20px;
              line-height: 30px;
              margin-right: 100px;
              font-size: 14px;
              text-align: center;
              cursor: pointer;
            }
            .btn3 {
              width: 100px;
              height: 30px;
              color: #666666;
              background: #fff;
              border-radius: 18px 18px 18px 18px;
              opacity: 1;
              border: 0;
              border: solid 1px #3964e6;
              font-size: 20px;
              line-height: 30px;
              margin-right: 100px;
              font-size: 14px;
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
